import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { Field } from 'pages/HelpCenter/IntellectualPropertyInfringement/constants';
import { stateName } from './constants';
export const initialState = {
  captchaUuid: undefined,
  filesToRetry: [],
  uploadUiState: UiState.Idle,
  failedFilenames: [],
  savedFiles: [],
  formData: null,
  formUiState: UiState.Idle,
  fieldErrors: {}
};

const setCaptchaUuid = (draft, _ref) => {
  let {
    payload
  } = _ref;
  draft.captchaUuid = payload.uuid;
};

const resetCaptchaUuid = draft => {
  draft.captchaUuid = undefined;
};

const uploadFilesRequest = draft => {
  draft.uploadUiState = UiState.Pending;
  draft.failedFilenames = [];
  draft.filesToRetry = [];
};

const uploadFilesSuccess = (draft, _ref2) => {
  let {
    payload
  } = _ref2;
  draft.uploadUiState = UiState.Success;
  draft.savedFiles = draft.savedFiles.concat(payload.savedFiles);
};

const deleteSavedFile = (draft, _ref3) => {
  let {
    payload
  } = _ref3;
  draft.savedFiles = draft.savedFiles.filter(file => file.id !== payload.id);
};

const addFileToRetry = (draft, _ref4) => {
  let {
    payload
  } = _ref4;
  draft.filesToRetry.push(payload.file);
};

const addFailedFilename = (draft, _ref5) => {
  let {
    payload
  } = _ref5;
  draft.failedFilenames.push(payload.filename);
};

const submitFormRequest = draft => {
  draft.formUiState = UiState.Pending;
  draft.formData = null;
  draft.fieldErrors = {};
};

const submitFormSuccess = draft => {
  draft.formUiState = UiState.Success;
  draft.formData = null;
  draft.savedFiles = [];
};

const submitFormFailure = (draft, _ref6) => {
  let {
    payload
  } = _ref6;
  payload.errors.forEach(error => {
    if (error.field !== 'property_rights.illegal_contents.urls') return;
    const urls = error.value.split(',');
    if (!urls.length) return;
    draft.fieldErrors[Field.InfringingUrlsTextArea] = urls;
  });
  draft.formUiState = Object.keys(draft.fieldErrors).length ? UiState.Idle : UiState.Failure;
};

const setFormData = (draft, _ref7) => {
  let {
    payload
  } = _ref7;
  draft.formData = payload.formData;
};

const setFormUiState = (draft, _ref8) => {
  let {
    payload
  } = _ref8;
  draft.formUiState = payload.formUiState;
};

const intellectualPropertyInfringementSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setCaptchaUuid,
    resetCaptchaUuid,
    uploadFilesRequest,
    uploadFilesSuccess,
    addFileToRetry,
    addFailedFilename,
    deleteSavedFile,
    submitFormRequest,
    submitFormSuccess,
    submitFormFailure,
    setFormData,
    setFormUiState
  }
});
export const {
  actions
} = intellectualPropertyInfringementSlice;
export const plug = {
  [stateName]: intellectualPropertyInfringementSlice.reducer
};
export default intellectualPropertyInfringementSlice.reducer;